<template>
  <div id="page">
      <Navbar :title="'Edit Dashboard'" :backBtn="'Dashboards'"/>
      <div class="page-content header-clear-medium padding-sides">
            <div class="travel-list-container" >
                <h2 class="bold center-text">Edit Internal</h2>
                <div class="divider divider-margins"></div>

                <div v-if="loaded">
                    <form @submit.prevent="editDashboard" >
                    
                        <ui-textbox
                            help="The Title for the navigation menu"
                            label="Tab name"
                            placeholder="Enter tab name"
                            v-model="dashboard.tab"
                        ></ui-textbox>

                        <!-- <ui-textbox
                            help="The PowerBI url for the iFrame"
                            label="Url"
                            placeholder="Enter dashboard url"
                            v-model="dashboard.url"
                        ></ui-textbox> -->

                        <ui-switch v-model="live" switch-position="right" style="padding-bottom: 20px">Live</ui-switch>
                        <ui-switch v-model="dashboard.home" switch-position="right" style="padding-bottom: 20px">Home</ui-switch>

                        <p class="feedback" v-if="feedback">{{ feedback }}</p>
                        <div class="clear"></div>
                        <div class="center-allign">
                            <ui-button color="primary" :loading="loading" >Update</ui-button>
                            
                        </div>


                    </form>
                    
                    <h2 class="bold center-text" style="margin-top: 2em; margin-bottom: 1em">Internal Links</h2>
                    <div class="center-allign">
                        <router-link :to="{ name: 'NewLink' }" style="margin-bottom: 1em;" class="ui-button ui-button--type-primary ui-button--color-primary ui-button--icon-position-left ui-button--size-normal">New Link</router-link>
                    </div>
                    <div class="link-list link-list-2 link-list-long-border">
                        <div class="contract" v-for="link in links" :key="link.id">
                            <router-link :to="{name: 'EditInternalLink', params: { link_slug: link.id }}"> 
                                <!-- link status -->
                                <div v-if="link.status == 'live'">
                                    <i class="fas fa-check color-green2-dark" style="left: -45px"></i>
                                    <em class="bg-green2-dark">Live</em>
                                </div>
                                <div v-if="link.status == 'offline'">
                                    <i class="fa fa-pen color-red2-dark" style="left: -45px"></i>
                                    <em class="bg-red2-dark">Offiline</em>
                                </div>

                                <span>{{ link.title }}</span>
                                <strong></strong>
                                <i class="fa fa-angle-right"></i>
                            </router-link>
                        </div>
                    </div>
                </div>
                <div v-else class="cap-center">
                    <div class="preload-spinner preload-small border-highlight"></div>
                </div>

            </div>
        </div>
        <div class="menu-hider"></div>
  </div>
</template>

<script>
import * as firebase from 'firebase/app'
import 'firebase/firestore'
import Navbar from '@/components/layouts/Navbar'

export default {
    name: 'NewDashboard',
    components:{
        Navbar
    },
    data(){
        return {
            isAdmin: false,
            dashboard: {
                tab: null,
            },
            links: [],
            slug: null,
            live: false,
            feedback: null,
            loading: false,
            loaded: false,
        }
    },
    methods:{
        editDashboard(){
            this.loading = true
            if(this.dashboard.tab){
                this.feedback = null
                let status
                if (this.live){
                    status = 'live'
                } else {
                    status = 'offline'
                }
                firebase.firestore().collection('dashboards').doc('internal').update({
                    status,
                    home: this.dashboard.home,
                    tab: this.dashboard.tab,
                }).then(() => {
                    this.feedback = 'The data has been updated successfully'
                }).catch(err => {
                    this.feedback = err
                })
            } else {
                this.feedback = 'The tab field is compulsory'
            }
            this.loading = false
        },
        showConfirm(ref) {
            this.$refs[ref].open();
        },
        onConfirmDelete() {
            console.log('You chose to delete the post.')
        },
        onDenyDelete() {
            console.log('You chose to keep the post.')
        }
    },
    mounted(){
        firebase.firestore().collection('dashboards').doc('internal').get()
        .then(doc => {
            this.dashboard = doc.data()
            if (this.dashboard.status == 'live'){
                this.live = true
            }
            
            return firebase.firestore().collection('dashboards').doc('internal').collection('links').get()
        }).then(snapshot => {
            snapshot.forEach(doc => {
                let link = doc.data()
                link.id = doc.id
                this.links.push(link)
            })

            this.loaded = true
        }).catch(e => {
            console.log(e)
        })
    }
}
</script>

<style>

</style>